import Vue from 'vue'
import Mint from 'mint-ui'
import ElementUI from 'element-ui'
import router from './router'
import store from './stores'
import Header from './components/Header'
import Menu from './components/Menu'
import PcOnly from './components/PcOnly'
import PhoneOnly from './components/PhoneOnly'
import getUnitName from './filters/getUnitName'
import DateUtil from './filters/format'
import $ from 'jquery'

import { aspectFill, aspectFit, widthFix, fixPrefix } from './filters/crop_img'
// import './registerServiceWorker'
import './helpers/listenStorage'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/theme.less'
import 'normalize.css'
import '../public/styles/mint-ui.css'

import './assets/global.less'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faChevronRight,
  faAngleRight,
  faSearch,
  faSortAmountUp,
  faSortAmountDown
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VuePreview from 'vue2-preview'
library.add(
  faChevronRight,
  faAngleRight,
  faSearch,
  faSortAmountUp,
  faSortAmountDown
)

Vue.component('ymt-header', Header)
Vue.component('ymt-menu', Menu)
Vue.component('pc-only', PcOnly)
Vue.component('phone-only', PhoneOnly)
Vue.component('fa-icon', FontAwesomeIcon)

Vue.filter('getUnitName', getUnitName)
Vue.filter('formatTime', DateUtil.format)
Vue.filter('aspectFill', aspectFill)
Vue.filter('aspectFit', aspectFit)
Vue.filter('widthFix', widthFix)
Vue.filter('fixPrefix', fixPrefix)

Vue.use(Mint)
Vue.use(ElementUI)
Vue.use(VuePreview)
Vue.config.productionTip = false
$(window).resize(function() {
  store.commit('updateWinHeight')
  store.commit('updateUiMode')
})
new Vue({
  router,
  store,
  render: h => h('router-view')
}).$mount('#app')
